import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.document.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "documentSearch",
  fields: [
    name
  ]
}
